<div class="pagePadding">
  <div class="container">
    <embed [src]="safePdfUrl" type="application/pdf" width="100%" height="600px" />
  </div>
</div>